<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para2"><a id="page_vii"></a>“Let Enkidu go ahead of you;<br/>for he knows the road to the Cedar Forest…”</p>
<p class="para3">—Tablet III<br/><em>The Epic of Gilgamesh</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatterb.vue?31ed567e